<span class="badge-status info" *ngIf="currentLevel == ambassadorPromotionLevelEnum.ConsumerAmbassador">
  {{ 'ambassadors.consumerAmbassador' | translate }}
</span>
<span class="badge-status active" *ngIf="currentLevel == ambassadorPromotionLevelEnum.ProfessionalAmbassador">
  {{ 'ambassadors.professionalAmbassador' | translate }}
</span>
<span class="badge-status warning" *ngIf="currentLevel == ambassadorPromotionLevelEnum.LeadAmbassador">
  {{ 'ambassadors.leadAmbassador' | translate }}
</span>

